import {
  Component,
  Input,
} from '@angular/core';

@Component({
    selector: 'simple-modal',
    templateUrl: './simple-modal.component.html',
    styleUrls: ['./simple-modal.component.scss'],
    standalone: false
})
export class SimpleModalComponent {
  @Input() public title!: string | undefined;
  @Input() public subtitle?: string;
  @Input() public bigIcon?: 'check' | 'dots';

  public isVisible = false;

  @Input() set visible(value: any) {
    this.isVisible = !!value;
  }
}
